import Dialog from '@123/druid/dist/Components/Window/Dialog/Dialog';
import type DialogOptions from '@123/druid/dist/Components/Window/Dialog/DialogOptions';
import type MessageDialogState from '@Component/Dialog/Message/Type/MessageDialogState';

export default class MessageDialogFactory {
    public success(title: string, content: string, footer: string = '', icon: string = '', options?: DialogOptions): Promise<void> {
        return this.messageDialog('success', title, content, footer, icon, options);
    }

    public warning(title: string, content: string, footer: string = '', icon: string = '', options?: DialogOptions): Promise<void> {
        return this.messageDialog('warning', title, content, footer, icon, options);
    }

    public error(title: string, content: string, footer: string = '', icon: string = '', options?: DialogOptions): Promise<void> {
        return this.messageDialog('error', title, content, footer, icon, options);
    }

    public info(title: string, content: string, footer: string = '', icon: string = '', options?: DialogOptions): Promise<void> {
        return this.messageDialog('info', title, content, footer, icon, options);
    }

    private messageDialog(
        state: keyof MessageDialogState,
        title: string,
        content: string,
        footer: string = '',
        icon: string = '',
        options?: DialogOptions,
    ): Promise<void> {
        return new Promise(() => {
            new Dialog(<DialogOptions>{
                title,
                content,
                footer,
                classes: {
                    frame: `dr-message-dialog dr-message-dialog--${state}`,
                    header: 'dr-message-dialog__header',
                    title: 'dr-message-dialog__title',
                    icon: `c-icon ${icon}`,
                    close: 'c-icon c-icon__cross c-icon--small',
                    wrapper: 'dr-message-dialog__content',
                    content: 'dr-message-dialog__description',
                    footer: 'dr-message-dialog__footer',
                },
                minHeight: 0,
                draggable: false,
                width: 600,
                edgeMargin: 32,
                ...options,
            }).show();
        });
    }
}
